import axiosInstance from '../axiosInstance';
import {
  GET_FARM_ENTITIES_SERVICE_URL,
  GET_FARM_ENTITIES_STATE_SERVICE_URL,
} from './config';

export const api = {
  async getFarmEntity(farmId) {
    const getFarmOverviewEntity = GET_FARM_ENTITIES_SERVICE_URL + farmId;
    return axiosInstance.get(getFarmOverviewEntity);
  },

  getFarmEntitiesState: (farmId) => {
    const getFarmEntitiesState = GET_FARM_ENTITIES_STATE_SERVICE_URL + farmId;
    return axiosInstance.get(getFarmEntitiesState);
  },
};

export default { api };
